import * as React from 'react';
import { useParams } from 'react-router-dom';
import { BookingPaymentTerms } from 'cb-model';
import { Display, NavIconContainer, PageTitle, QuerySingle, Section } from 'gossamer-front-end';

export const BookingPaymentTermsDisplay = (): React.JSX.Element => {
  const params = useParams();
  return (
    <>
      <NavIconContainer entityId={BookingPaymentTerms.id} />
      <PageTitle
        verb="Display"
        entity={BookingPaymentTerms}
        keyValue={params.key}
        subtitle="Details of Booking Payment Terms"
      />
      <Section>
        <QuerySingle entity={BookingPaymentTerms} keyValue={params.key} render={Display} />
      </Section>
    </>
  );
};
